import './PetProfile.scss';

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { loadAppointmentsRequests } from 'actions/appointments';
import FullScreenLoader from 'atoms/full-screen-loader';
import ListItem from 'organisms/Appointments/List/ListItem';
import NewAppointmentButton from 'organisms/NewAppointmentButton';
import { DISPLAY_NEW_APPOINTMENT_BUTTON } from 'pages/Appointments/Header';

import { PetInformation } from './PetInformation';

function PetProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [petInformation, setPetInformation] = useState();
  const { petAppointments } = useSelector((state) => state.petInformation);
  const { active, past } = petAppointments;
  const pastAppointments = past;
  const bookedAppointments = active.filter((appt) => appt.status.id === 1);
  const requestedAppointments = active.filter((appt) => appt.status.id === 2);

  useEffect(() => {
    dispatch(loadAppointmentsRequests(params.petId)).then(
      ({ success, data }) => {
        if (success) {
          const { active, past } = data.data;
          if (!active.length && !past.length) navigate('/appointments');
          setPetInformation(active[0] || past[0]);
        }
      }
    );
  }, []);

  if (!petInformation) return <FullScreenLoader />;

  return (
    <div className="flex-row w-100 pet-profile">
      <Helmet title="Pet profile | PawCare" />
      <PetInformation pet={petInformation} />
      <div className="page-container plr-20">
        <div className="flex-row justify-end mt-45">
          {DISPLAY_NEW_APPOINTMENT_BUTTON && (
            <NewAppointmentButton
              data={{
                client: {
                  avatarUrls: petInformation?.animal?.avatarUrls,
                  breed: petInformation?.animal?.breed,
                  name: petInformation?.animal?.name,
                  size: petInformation?.animal?.size,
                  type: petInformation?.animal?.type,
                  uuid: petInformation?.animal?.uuid,
                  owner: {
                    firstName: petInformation?.user?.firstName,
                    lastName: petInformation?.user?.lastName,
                    payment: petInformation?.user?.payment,
                    phone: petInformation?.user?.phone,
                    uuid: petInformation?.user?.uuid,
                  },
                },
              }}
            />
          )}
        </div>
        {requestedAppointments.length > 0 && (
          <div className="mb-35">
            <h2 className="mb-15">New request</h2>

            {requestedAppointments.map((item) => (
              <ListItem
                showInnerDate
                showOutterDate={false}
                showUserNumber={false}
                showPetDetails={false}
                showAvatar={false}
                key={item.uuid}
                item={item}
                isNewRequest
              />
            ))}
          </div>
        )}
        {bookedAppointments.length > 0 && (
          <div className="mb-35">
            <h2 className="mb-15">Scheduled</h2>
            {bookedAppointments.map((item) => (
              <ListItem
                showInnerDate
                showOutterDate={false}
                showUserNumber={false}
                showPetDetails={false}
                showAvatar={false}
                key={item.uuid}
                item={item}
              />
            ))}
          </div>
        )}
        {pastAppointments.length > 0 && (
          <div className="mb-35">
            <h2 className="mb-15">Past</h2>

            {pastAppointments.map((item) => (
              <ListItem
                showInnerDate
                showOutterDate={false}
                showUserNumber={false}
                showPetDetails={false}
                showAvatar={false}
                key={item.uuid}
                item={item}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PetProfile;
